/**
 * Resolve an avatar image URL for a person.
 *
 * Order of preference:
 *   1. A real uploaded photo URL (non-empty; must not itself be a
 *      ui-avatars.com URL — that would recurse a fallback into a
 *      fallback and defeat the point).
 *   2. A generated initials avatar from ui-avatars.com (no install,
 *      free, deterministic per name, sized).
 *
 * Signature stays backwards-compatible with the previous version:
 *   getAvatar(name)              → initials fallback
 *   getAvatar(name, photo)       → photo if truly usable, else initials
 *   getAvatar(name, photo, size) → sized initials fallback
 */
export function getAvatar(
  name: string | null | undefined,
  uploaded?: string | null,
  size: number = 40
): string {
  const trimmed = (uploaded || "").trim();
  if (trimmed !== "" && !trimmed.includes("ui-avatars.com")) {
    return trimmed;
  }
  const safeName = encodeURIComponent((name || "?").trim() || "?");
  return `https://ui-avatars.com/api/?name=${safeName}&background=random&color=fff&size=${size}&rounded=true&bold=true`;
}
